export const PromiseFulfilled = "fulfilled";
